module.exports = __webpack_public_path__ + "img/msg-red.7daa4b1d.svg";